import { render, staticRenderFns } from "./UpdateAccountSchool.vue?vue&type=template&id=031d7ac0&scoped=true"
import script from "./UpdateAccountSchool.vue?vue&type=script&lang=js"
export * from "./UpdateAccountSchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountSchool.vue?vue&type=style&index=0&id=031d7ac0&lang=css"
import style1 from "./UpdateAccountSchool.vue?vue&type=style&index=1&id=031d7ac0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d7ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031d7ac0')) {
      api.createRecord('031d7ac0', component.options)
    } else {
      api.reload('031d7ac0', component.options)
    }
    module.hot.accept("./UpdateAccountSchool.vue?vue&type=template&id=031d7ac0&scoped=true", function () {
      api.rerender('031d7ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/UpdateAccountSchool.vue"
export default component.exports